import { render, staticRenderFns } from "./Range.vue?vue&type=template&id=883a8272&scoped=true"
var script = {}
import style0 from "./Range.vue?vue&type=style&index=0&id=883a8272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883a8272",
  null
  
)

export default component.exports